// src/routes.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom'
import { Switch, Route } from "react-router";
 

import Login from './pages/Login';
import {User, Store} from './pages/Register';
import {Home} from './pages/Home';
import {StoreList , Detail} from './pages/Store';
import {Promotion} from './pages/Promotion';
import Contact from './pages/Contact';







export default () => {
    return (
        <BrowserRouter>
                    <Switch>
                        <Route exact path={'/auth'} component={Login} />
                        <Route exact path={'/create_user'} component={User} />
                        <Route exact path={'/create_store'} component={Store} />
                        <Route exact path={'/'} component={Home} />
                        <Route exact path={'/store'} component={StoreList} />
                        <Route exact path={'/detail/:id'} component={Detail} />
                        <Route exact path={'/promotion'} component={Promotion} />
                        <Route exact path={'/contact'} component={Contact} />

                        {/* <Route component={NotFound} /> */}
                    </Switch>
        </BrowserRouter>
    )

}
